<div class="route-component">
    <div class="form-component">

        <tab-control>
            <tab-page title="Bulk Ageing Export Report" icon="fas fa-user-pen">
                <h4>
                    Input Report Parameters
                </h4>

                <form #form="ngForm" (ngSubmit)="onRunReport(form)">
                    <!-- Start Period ID -->
                    <div class="input-group">
                        <auto-complete-dropdown
                            [options]="periods"
                            [label]="'Start Period'"
                            [placeholder]="'Select start period...'"
                            [initialValue]="selectedStartPeriodId"
                            [required]="true"
                            [invalid]="!selectedStartPeriodId && formSubmitted"
                            [validationMessage]="'Start Period is required'"
                            [displayWith]="displayPeriod"
                            (selectionChange)="onStartPeriodChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- End Period ID -->
                    <div class="input-group">
                        <auto-complete-dropdown
                            [options]="periods"
                            [label]="'End Period'"
                            [placeholder]="'Select end period...'"
                            [initialValue]="selectedEndPeriodId"
                            [required]="true"
                            [invalid]="!selectedEndPeriodId && formSubmitted"
                            [validationMessage]="'End Period is required'"
                            [displayWith]="displayPeriod"
                            (selectionChange)="onEndPeriodChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Insurer -->
                    <div class="input-group">
                        <auto-complete-dropdown
                            [options]="insurers"
                            [label]="'Insurer'"
                            [placeholder]="'Select an insurer...'"
                            [initialValue]="selectedInsurerId"
                            [required]="true"
                            [invalid]="!selectedInsurerId && formSubmitted"
                            [validationMessage]="'Insurer is required'"
                            (selectionChange)="onInsurerSelectionChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Action Bar -->
                    <div class="action-bar">
                        <button type="submit" class="button" [disabled]="form.invalid">
                            <i class="fas fa-fire"></i>
                            Run Report
                        </button>
                    </div>
                </form>
            </tab-page>
        </tab-control>

    </div>
</div>